module.exports = __webpack_public_path__ + "static/food_security-15e0de43a615a4ff86b89b9fdbb3e332.png";